/**
 * main-product-redesign.js â€” MitoPRO+ v3
 * Handles: gallery, variant selection, gallery rebuild by alt,
 *          arrays sheet (mobile only) / always-visible panel (desktop),
 *          size card, sticky bar, quiz, cart AJAX with addon checkboxes
 */
(function () {
  'use strict';

  /* â”€â”€ 1. Data â”€â”€ */
  const dataEl = document.getElementById('mpr-data');
  if (!dataEl) return;
  let D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  const variants = D.variants || [];
  const allMedia = D.media || [];
  const sizeMeta = D.sizeMeta || {};

  /* â”€â”€ 2. DOM refs â”€â”€ */
  const variantInput  = document.getElementById('mpr-variant-id');
  const priceNow      = document.getElementById('mpr-price-now');
  const priceWas      = document.getElementById('mpr-price-was');
  const priceSave     = document.getElementById('mpr-price-save');
  const priceMo       = document.getElementById('mpr-price-mo');
  const atcBtn        = document.getElementById('mpr-atc-btn');
  const atcText       = document.getElementById('mpr-atc-text');
  const atcPrice      = document.getElementById('mpr-atc-price');
  const spinner       = document.getElementById('mpr-spinner');
  const galleryMain   = document.getElementById('mpr-gallery-main');
  const galleryDots   = document.getElementById('mpr-dots');
  const galleryThumbs = document.getElementById('mpr-thumbs');
  const prevBtn       = document.getElementById('mpr-prev');
  const nextBtn       = document.getElementById('mpr-next');
  const counter       = document.getElementById('mpr-counter');
  const stickyBar     = document.getElementById('mpr-sticky');
  const stickyVariant = document.getElementById('mpr-sticky-variant');
  const stickyPrice   = document.getElementById('mpr-sticky-price');
  const stickyAtc     = document.getElementById('mpr-sticky-atc');
  const stickyThumb   = document.getElementById('mpr-sticky-thumb');
  const sizeDims      = document.getElementById('mpr-size-dims');
  const arrTrigger    = document.getElementById('mpr-arr-trigger');
  const arrOverlay    = document.getElementById('mpr-arr-overlay');
  const arrClose      = document.getElementById('mpr-arr-close');
  const quizTrigger   = document.getElementById('mpr-quiz-trigger');
  const quizOverlay   = document.getElementById('mpr-quiz-overlay');
  const quizClose     = document.getElementById('mpr-quiz-close');
  const quizResult    = document.getElementById('mpr-quiz-result');
  const quizRecName   = document.getElementById('mpr-quiz-rec-name');
  const quizRecWhy    = document.getElementById('mpr-quiz-rec-why');
  const quizSelect    = document.getElementById('mpr-quiz-select');

  let currentSlide = 0;
  let slides = [], dots = [], thumbs = [];
  let currentVariantId = null;
  let isMobile = () => window.innerWidth < 900;

  /* â”€â”€ 3. Format money â”€â”€ */
  function money(cents) {
    if (!cents && cents !== 0) return '';
    const sym = (window.Shopify?.currency?.active === 'GBP') ? 'Â£'
              : (window.Shopify?.currency?.active === 'EUR') ? 'â‚¬' : '$';
    return sym + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* â”€â”€ 4. Gallery â”€â”€ */
  function initGallery() {
    if (!galleryMain) return;
    slides = [...galleryMain.querySelectorAll('.mpr__slide')];
    dots   = galleryDots  ? [...galleryDots.querySelectorAll('.mpr__dot')]  : [];
    thumbs = galleryThumbs ? [...galleryThumbs.querySelectorAll('.mpr__thumb')] : [];

    dots.forEach(d => d.addEventListener('click', () => goTo(+d.dataset.dot)));
    thumbs.forEach(t => t.addEventListener('click', () => goTo(+t.dataset.thumb)));
    updateCounter();
  }

  /* Touch swipe â€” attached once only */
  if (galleryMain) {
    let tx = 0;
    galleryMain.addEventListener('touchstart', e => { tx = e.changedTouches[0].clientX; }, { passive: true });
    galleryMain.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 40) goTo(dx < 0 ? (currentSlide + 1) % slides.length : (currentSlide - 1 + slides.length) % slides.length);
    }, { passive: true });
  }

  /* Prev/next â€” attached once only, uses shared slides variable */
  if (prevBtn) prevBtn.addEventListener('click', () => goTo((currentSlide - 1 + slides.length) % slides.length));
  if (nextBtn) nextBtn.addEventListener('click', () => goTo((currentSlide + 1) % slides.length));

  function goTo(i) {
    if (!slides.length) return;
    i = Math.max(0, Math.min(i, slides.length - 1));
    slides[currentSlide]?.classList.remove('is-active');
    dots[currentSlide]?.classList.remove('is-active');
    thumbs[currentSlide]?.classList.remove('is-active');
    currentSlide = i;
    slides[i]?.classList.add('is-active');
    dots[i]?.classList.add('is-active');
    thumbs[i]?.classList.add('is-active');
    thumbs[i]?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    updateCounter();
  }

  function updateCounter() {
    if (counter) counter.textContent = (currentSlide + 1) + ' / ' + slides.length;
  }

  function rebuildGallery(variant) {
    if (!galleryMain || !allMedia.length) return;

    /* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
       FIX: Only rebuild when there's a real, matched variant-image pool.
       Previously, single-variant products (and variants with no alt-tag
       match) fell through to a 1-image fallback, which:
         â€¢ collapsed the carousel to a single slide (arrows looked dead)
         â€¢ stripped the original <img data-media-id=...> used by the
           theme's image lightbox, so clicking images did nothing.
       Now: if we can't improve on the server-rendered gallery, leave it.
       â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
    if (variants.length <= 1) return;

    const targetAlt = variant.alt;
    if (!targetAlt) return;

    const pool = allMedia.filter(m => m.alt === targetAlt);
    if (!pool.length) return;

    // Rebuild slides
    galleryMain.querySelectorAll('.mpr__slide').forEach(s => s.remove());
    pool.forEach((m, i) => {
      const div = document.createElement('div');
      div.className = 'mpr__slide' + (i === 0 ? ' is-active' : '');
      div.dataset.slide = i;
      if (m.type === 'image') {
        // Preserve data-media-id so the theme's lightbox/zoom keeps working
        div.innerHTML = `<div class="mpr__media"><img src="${m.src}" srcset="${m.srcset || m.src}" alt="${(m.alt || '').replace(/"/g, '&quot;')}" loading="${i === 0 ? 'eager' : 'lazy'}" class="mpr__img" data-media-id="${m.id}" width="900" height="900"></div>`;
      } else {
        div.innerHTML = `<div class="mpr__media mpr__media--video"><div style="color:#fff;font-size:32px;display:flex;align-items:center;justify-content:center;width:100%;height:200px">â–¶</div></div>`;
      }
      const firstNav = galleryMain.querySelector('.mpr__nav--prev');
      if (firstNav) galleryMain.insertBefore(div, firstNav);
      else galleryMain.appendChild(div);
    });

    // Rebuild dots
    if (galleryDots) {
      galleryDots.innerHTML = pool.map((_, i) =>
        `<button class="mpr__dot${i === 0 ? ' is-active' : ''}" data-dot="${i}"></button>`
      ).join('');
    }

    // Rebuild thumbs
    if (galleryThumbs) {
      galleryThumbs.innerHTML = pool.map((m, i) =>
        `<button class="mpr__thumb${i === 0 ? ' is-active' : ''}" data-thumb="${i}" aria-label="Image ${i + 1}">
          <img src="${m.thumb || m.src}" alt="${(m.alt || '').replace(/"/g, '&quot;')}" width="72" height="72" loading="lazy">
        </button>`
      ).join('');
    }

    // Update sticky thumb
    if (stickyThumb) stickyThumb.src = pool[0].thumb || pool[0].src;

    currentSlide = 0;
    initGallery();
  }

  /* â”€â”€ 5. Variant selection â”€â”€ */
  function selectVariant(id, source) {
    const v = variants.find(x => x.id === id);
    if (!v) return;
    currentVariantId = id;

    if (variantInput) variantInput.value = id;

    // â”€â”€ Update URL so sharing and back/forward work correctly â”€â”€
    if (source !== 'init') {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      window.history.replaceState({ variantId: id }, '', url.toString());
    }

    if (priceNow) priceNow.textContent = money(v.price);
    if (priceMo) priceMo.textContent = money(Math.round(v.price / 36));

    if (v.compare && v.compare > v.price) {
      if (priceWas) { priceWas.textContent = money(v.compare); priceWas.style.display = ''; }
      if (priceSave) { priceSave.textContent = 'Save ' + money(v.compare - v.price); priceSave.style.display = ''; }
    } else {
      if (priceWas) priceWas.style.display = 'none';
      if (priceSave) priceSave.style.display = 'none';
    }

    if (atcBtn) {
      atcBtn.disabled = !v.available;
      atcBtn.setAttribute('aria-disabled', String(!v.available));
    }
    if (atcText) {
      if (v.available) {
        atcText.innerHTML = 'Add to cart” <strong id="mpr-atc-price">' + money(v.price) + '</strong>';
      } else {
        atcText.textContent = 'Sold out';
      }
    }

    if (stickyVariant) stickyVariant.textContent = v.title;
    if (stickyPrice) stickyPrice.textContent = money(v.price);
    if (stickyAtc) {
      stickyAtc.disabled = !v.available;
      stickyAtc.textContent = v.available ? 'Add to cart' : 'Sold out';
      stickyAtc.dataset.variantId = id;
    }

    updateSizeCard(v.title);
    rebuildGallery(v);

    // Update URL to reflect selected variant (enables sharing, back/forward, analytics)
    

    document.querySelectorAll('[data-variant-id]').forEach(el => {
      el.classList.toggle('is-selected', +el.dataset.variantId === id);
    });
    document.querySelectorAll('.mpr__sheet-row').forEach(el => {
      el.classList.toggle('is-selected', +el.dataset.variantId === id);
    });

    const terms = document.getElementById('shopify-installments-button');
    if (terms) terms.setAttribute('variant-id', id);

    document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: v }, bubbles: true }));
    updateAddonsForVariant(v.id);
  }

  /* â”€â”€ Addon grid swap on variant change â”€â”€ */
  const addonCache = {};

  async function fetchAddonData(handle) {
    if (addonCache[handle]) return addonCache[handle];
    try {
      const r = await fetch(`/products/${handle}.js`);
      const p = await r.json();
      const v = p.variants[0];
      addonCache[handle] = { id: v.id, price: v.price, name: p.title, img: p.featured_image };
      return addonCache[handle];
    } catch(e) { return null; }
  }

  async function updateAddonsForVariant(variantId) {
    const grid = document.getElementById('mpr-addons-grid');
    if (!grid) return;
    const variantAddons = D.variantAddons || {};
    const handles = variantAddons[String(variantId)];
    if (!handles || handles.length === 0) return;

    const addonData = (await Promise.all(handles.map(fetchAddonData))).filter(Boolean);
    if (addonData.length === 0) return;

    grid.innerHTML = addonData.map((a, i) => `
      <label class="mpr__addon" data-addon-id="${a.id}" data-addon-price="${a.price}">
        <span class="mpr__addon-check-wrap" aria-hidden="true">
          <input type="checkbox" class="mpr__addon-cb sr-only" id="mpr-addon-${i+1}"
            data-addon-id="${a.id}" data-addon-price="${a.price}" data-addon-name="${a.name}">
          <span class="mpr__addon-checkbox" aria-hidden="true">
            <svg class="mpr__addon-check-icon" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8l3.5 3.5 6.5-6.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </span>
        </span>
        ${a.img ? `<img src="${a.img}" alt="${a.name}" width="52" height="52" loading="lazy" class="mpr__addon-img">` : ''}
        <div class="mpr__addon-info">
          <span class="mpr__addon-name">${a.name}</span>
          <span class="mpr__addon-price">${money(a.price)}</span>
        </div>
        <span class="mpr__addon-add-label" aria-hidden="true">Add</span>
      </label>`).join('');
    initAddonCheckboxes();
  }

  /* â”€â”€ 6. Size card â”€â”€ */
  function updateSizeCard(title) {
    if (!sizeDims) return;
    const m = sizeMeta[title];
    if (!m) { sizeDims.innerHTML = ''; return; }
    sizeDims.innerHTML = [
      dim('Width', m.w),
      dim('Panel height', m.h),
      dim('With stand', m.hs),
      dim('LEDs', m.leds.toLocaleString()),
      dim('Power', m.power),
      dim('Best for', m.best)
    ].join('');
  }
  function dim(label, val) {
    const display = typeof val === 'string' ? val.replace(/in\b/g, '\"') : val;
    return `<div class="mpr__size-dim"><span class="mpr__size-dim-label">${label}</span><span class="mpr__size-dim-val">${display}</span></div>`;
  }

  /* â”€â”€ 7. Variant button listeners â”€â”€ */
  function bindVariantBtns() {
    document.querySelectorAll('.mpr__vpill, .mpr__arr-row').forEach(el => {
      el.addEventListener('click', () => {
        selectVariant(+el.dataset.variantId, 'main');
      });
    });

    document.querySelectorAll('.mpr__sheet-row').forEach(el => {
      el.addEventListener('click', () => {
        selectVariant(+el.dataset.variantId, 'sheet');
        closeSheet(arrOverlay);
      });
    });
  }

  /* â”€â”€ 8. Arrays toggle â”€â”€ */
  function initArraysToggle() {
    if (!arrTrigger) return;
    arrTrigger.addEventListener('click', () => {
      if (isMobile()) openSheet(arrOverlay);
    });
    if (arrClose) arrClose.addEventListener('click', () => closeSheet(arrOverlay));
    if (arrOverlay) arrOverlay.addEventListener('click', e => {
      if (e.target === arrOverlay) closeSheet(arrOverlay);
    });
  }

  /* â”€â”€ 9. Sheet helpers â”€â”€ */
  function openSheet(overlay) {
    if (!overlay) return;
    overlay.classList.add('is-open');
    overlay.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
  }
  function closeSheet(overlay) {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* â”€â”€ 10. Quiz â”€â”€ */
const quizRecs = [
    { area: 0, space: 0, variantRank: 0, why: 'Great for targeted face and neck treatment. Our most compact panel â€” easy to position on a desk.' },
    { area: 0, space: 1, variantRank: 0, why: 'Ideal for face and neck. A focused, clinically effective panel for this zone.' },
    { area: 0, space: 2, variantRank: 0, why: 'For face and neck, the smallest panel is the right tool â€” no need for a larger panel.' },
    { area: 1, space: 0, variantRank: 1, why: 'Upper or lower body coverage in a compact footprint â€” ideal when space is limited.' },
    { area: 1, space: 1, variantRank: 1, why: 'Great for upper or lower body. Works perfectly on a stand with moderate space.' },
    { area: 1, space: 2, variantRank: 2, why: 'With plenty of space, step up to our largest single panel for the best full-body experience.' },
    { area: 2, space: 0, variantRank: 2, why: 'Most popular for full-body coverage. Maximises treatment area even in limited space.' },
    { area: 2, space: 1, variantRank: 2, why: 'Our most popular panel â€” full-body coverage with a stand.' },
    { area: 2, space: 2, variantRank: 2, why: 'Maximum full-body coverage with our largest panel. You have the space to make the most of it.' },
  ];

  let quizAnswers = {};
  let quizRecVariant = null;

  function initQuiz() {
    if (!quizTrigger) return;
    quizTrigger.addEventListener('click', () => openSheet(quizOverlay));
    if (quizClose) quizClose.addEventListener('click', () => closeSheet(quizOverlay));
    if (quizOverlay) quizOverlay.addEventListener('click', e => {
      if (e.target === quizOverlay) closeSheet(quizOverlay);
    });

    document.querySelectorAll('.mpr__quiz-opt input').forEach(inp => {
      inp.addEventListener('change', () => {
        const key = inp.closest('[data-key]')?.dataset.key;
        if (key) quizAnswers[key] = +inp.value;
        if (quizAnswers.area !== undefined && quizAnswers.space !== undefined) showQuizRec();
      });
    });

    if (quizSelect) {
      quizSelect.addEventListener('click', () => {
        if (quizRecVariant) {
          selectVariant(quizRecVariant, 'quiz');
          closeSheet(quizOverlay);
        }
      });
    }
  }

function showQuizRec() {
    const match = quizRecs.find(r => r.area === quizAnswers.area && r.space === quizAnswers.space);
    if (!match || !quizResult) return;

    // Get only the individual (non-array) variants, sorted by price ascending
    const individualVariants = variants.filter(v =>
      !v.title.includes('&') &&
      !v.title.toLowerCase().includes('2x') &&
      !v.title.toLowerCase().includes('4x') &&
      !v.title.includes('2Ã—') &&
      !v.title.includes('4Ã—')
    ).sort((a, b) => a.price - b.price);

    // Clamp rank to available variants (e.g. if product only has 1 or 2 individual variants)
    const rank = Math.min(match.variantRank, individualVariants.length - 1);
    const v = individualVariants[rank];

    quizRecVariant = v?.id || null;
    if (quizRecName) quizRecName.textContent = v?.title || '';
    if (quizRecWhy) quizRecWhy.textContent = match.why;
    quizResult.hidden = false;
  }

  /* â”€â”€ 11. Sticky bar â”€â”€ */
  function initStickyBar() {
    if (!stickyBar) return;

    if (stickyAtc) {
      stickyAtc.addEventListener('click', () => {
        document.getElementById('mpr-form')?.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }

    if (window.innerWidth < 900) {
      stickyBar.classList.add('is-visible');
      return;
    }

    const threshold = +(stickyBar.dataset.threshold || 400);
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          stickyBar.classList.toggle('is-visible', window.scrollY > threshold);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* â”€â”€ 12. Addons â”€â”€ */
  function getCheckedAddonIds() {
    const checked = [];
    document.querySelectorAll('.mpr__addon-cb:checked').forEach(cb => {
      const id = +cb.dataset.addonId;
      if (id) checked.push(id);
    });
    return checked;
  }

  /* â”€â”€ 13. Cart AJAX â”€â”€ */
  // â”€â”€ Cart bridge wrapper â€” PDP does not own drawer rendering anymore
  async function refreshAndOpenCartDrawer() {
    if (window.MRLCart && typeof window.MRLCart.refreshDrawer === 'function') {
      await window.MRLCart.refreshDrawer();
      if (typeof window.MRLCart.openDrawer === 'function') window.MRLCart.openDrawer();
      return true;
    }

    if (window.MRLCartDrawer && typeof window.MRLCartDrawer.refresh === 'function') {
      await window.MRLCartDrawer.refresh();
      if (typeof window.MRLCartDrawer.open === 'function') window.MRLCartDrawer.open();
      return true;
    }

    const drawer = document.querySelector('.cart-drawer');
    if (drawer) {
      drawer.classList.add('cart-drawer--active');
      document.body.style.overflowY = 'hidden';
      return true;
    }

    return false;
  }

  // â”€â”€ Cart drawer controls now live in drawerfunction.js / MRLCart.
  // PDP JS should not bind global drawer remove/quantity handlers.
  function initCartDrawerDelegation() {
    return;
  }

  function initCart() {
    const form = document.getElementById('mpr-form');
    if (!form) return;

    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (!atcBtn || atcBtn.disabled) return;

      atcBtn.disabled = true;
      if (spinner) spinner.style.display = '';
      if (atcText) atcText.style.opacity = '0.4';

      const mainId = currentVariantId || +(variantInput?.value);
      const addonIds = getCheckedAddonIds();

      const items = [{ id: mainId, quantity: 1 }];
      addonIds.forEach(id => items.push({ id, quantity: 1 }));

      try {
        let data = null;

        if (window.MRLCart && typeof window.MRLCart.addItems === 'function') {
          data = await window.MRLCart.addItems(items, {
            refreshDrawer: true,
            openDrawer: true
          });
        } else if (window.MRLCartDrawer && typeof window.MRLCartDrawer.addItems === 'function') {
          data = await window.MRLCartDrawer.addItems(items);
        } else {
          const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items })
          });
          data = await res.json().catch(() => ({}));

          if (!res.ok || data.status) throw new Error(data.description || data.message || 'Cart error');
          await refreshAndOpenCartDrawer();
        }

        document.querySelectorAll('.mpr__addon-cb:checked').forEach(cb => { cb.checked = false; });

        if (atcText) {
          const addedCount = items.length;
          const origHTML = atcText.innerHTML;
          atcText.innerHTML = addedCount > 1 ? `âœ“ ${addedCount} items added` : 'âœ“ Added to cart';
          atcText.style.opacity = '1';
          setTimeout(() => { if (atcText) { atcText.innerHTML = origHTML; atcText.style.opacity = '1'; } }, 2000);
        }

      } catch (err) {
        console.error('[MPR] Cart add error:', err);
        if (atcText) {
          atcText.textContent = 'Error â€” please try again';
          atcText.style.opacity = '1';
        }
        setTimeout(() => {
          const v = variants.find(x => x.id === currentVariantId);
          if (atcText && v) {
            atcText.innerHTML = v.available
              ? 'Add to cart â€” <strong>' + money(v.price) + '</strong>'
              : 'Sold out';
          }
        }, 2500);
      } finally {
        if (spinner) spinner.style.display = 'none';
        atcBtn.disabled = false;
        if (atcText) atcText.style.opacity = '1';
      }
    });
  }

  /* â”€â”€ 14. Addon checkbox visual sync â”€â”€ */
  function initAddonCheckboxes() {
    document.querySelectorAll('.mpr__addon').forEach(label => {
      const cb = label.querySelector('.mpr__addon-cb');
      if (!cb) return;
      const visual = label.querySelector('.mpr__addon-checkbox');
      if (visual) visual.setAttribute('role', 'presentation');
    });
  }

  /* â”€â”€ 15. Financing / HSA popovers â”€â”€ */
  function initPopovers() {
    document.querySelectorAll('.mpr__affirm-btn').forEach(btn => {
      btn.addEventListener('click', e => {
        e.stopPropagation();
        const id = 'mpr-popover-' + btn.dataset.popover;
        const popover = document.getElementById(id);
        if (!popover) return;
        const isOpen = !popover.hidden;
        document.querySelectorAll('.mpr__popover').forEach(p => p.hidden = true);
        popover.hidden = isOpen;
      });
    });

    document.querySelectorAll('.mpr__popover-close').forEach(btn => {
      btn.addEventListener('click', () => {
        btn.closest('.mpr__popover').hidden = true;
      });
    });

    document.addEventListener('click', () => {
      document.querySelectorAll('.mpr__popover').forEach(p => p.hidden = true);
    });
  }
/* â”€â”€ 16. Lightbox â”€â”€ */
function initLightbox() {
  if (document.getElementById('mpr-lightbox')) return;

  // Build DOM
  const lb = document.createElement('div');
  lb.id = 'mpr-lightbox';
  lb.className = 'mpr-lightbox';
  lb.setAttribute('role', 'dialog');
  lb.setAttribute('aria-label', 'Image zoom');
  lb.innerHTML = `
    <button class="mpr-lightbox__close" aria-label="Close zoom">&#x2715;</button>
    <button class="mpr-lightbox__prev" aria-label="Previous image">&#8249;</button>
    <img class="mpr-lightbox__img" src="" alt="" />
    <button class="mpr-lightbox__next" aria-label="Next image">&#8250;</button>
    <span class="mpr-lightbox__counter"></span>
  `;
  document.body.appendChild(lb);

  const img        = lb.querySelector('.mpr-lightbox__img');
  const btnClose   = lb.querySelector('.mpr-lightbox__close');
  const btnPrev    = lb.querySelector('.mpr-lightbox__prev');
  const btnNext    = lb.querySelector('.mpr-lightbox__next');
  const lbCounter  = lb.querySelector('.mpr-lightbox__counter');
  let lbIndex      = 0;
  let lbImages     = [];

  function collectImages() {
    // Only collect image slides (skip video slides)
    lbImages = [];
    if (!galleryMain) return;
    galleryMain.querySelectorAll('.mpr__slide').forEach((slide, i) => {
      const imgEl = slide.querySelector('img.mpr__img');
      if (!imgEl) return; // skip video slides
      // Use srcset largest size if available, otherwise src
      let fullSrc = imgEl.src;
      if (imgEl.srcset) {
        const parts = imgEl.srcset.split(',').map(s => s.trim());
        const last = parts[parts.length - 1];
        fullSrc = last.split(' ')[0];
      }
      lbImages.push({ src: fullSrc, alt: imgEl.alt, slideIndex: i });
    });
  }

  function open(slideIndex) {
    collectImages();
    // Find position in lbImages that matches this slideIndex
    const pos = lbImages.findIndex(x => x.slideIndex === slideIndex);
    lbIndex = pos >= 0 ? pos : 0;
    if (!lbImages.length) return;
    render();
    lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    lb.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function render() {
    const item = lbImages[lbIndex];
    if (!item) return;
    img.src = item.src;
    img.alt = item.alt;
    lbCounter.textContent = lbImages.length > 1 ? (lbIndex + 1) + ' / ' + lbImages.length : '';
    btnPrev.style.visibility = lbImages.length > 1 ? 'visible' : 'hidden';
    btnNext.style.visibility = lbImages.length > 1 ? 'visible' : 'hidden';
  }

  function prev() { lbIndex = (lbIndex - 1 + lbImages.length) % lbImages.length; render(); }
  function next() { lbIndex = (lbIndex + 1) % lbImages.length; render(); }

  // Click on any image slide opens lightbox
  if (galleryMain) {
    galleryMain.addEventListener('click', e => {
      const slide = e.target.closest('.mpr__slide');
      if (!slide) return;
      if (slide.querySelector('.mpr__media--video')) return; // don't zoom videos
      open(+slide.dataset.slide || 0);
    });
  }

  // Controls
  btnClose.addEventListener('click', close);
  btnPrev.addEventListener('click', e => { e.stopPropagation(); prev(); });
  btnNext.addEventListener('click', e => { e.stopPropagation(); next(); });
  lb.addEventListener('click', e => { if (e.target === lb) close(); }); // backdrop click

  // Keyboard
  document.addEventListener('keydown', e => {
    if (!lb.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') prev();
    if (e.key === 'ArrowRight') next();
  });
}
  /* â”€â”€ 17. Accordion scroll links â”€â”€ */
  function initAccordionLinks() {
    document.querySelectorAll('.mpr__acc-trigger--link').forEach(trigger => {
      trigger.addEventListener('click', e => {
        e.preventDefault();
        trigger.closest('details')?.removeAttribute('open');
        const targetId = trigger.dataset.scrollTo;
        const target = document.getElementById(targetId);
        if (target) {
          const offset = 80;
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      });
    });
  }

  /* â”€â”€ Init â”€â”€ */
  function init() {
    initGallery();
    bindVariantBtns();
    initArraysToggle();
    initQuiz();
    initStickyBar();
    initCart();
    initCartDrawerDelegation();
    initAddonCheckboxes();
    initAccordionLinks();
    initPopovers();
    initLightbox();

    // Set initial variant from URL or first variant
    const urlVariant = new URLSearchParams(window.location.search).get('variant');
    const initId = urlVariant ? +urlVariant : (variants[0]?.id || null);
    if (initId) {
      currentVariantId = initId;
      selectVariant(initId, 'init');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();